/**
 * Step 8 — Billing Setup
 *
 * Focuses solely on the Billing tab from Project Settings.
 * Invoice numbering mode and aged WIP thresholds.
 */

import { StepWrapper } from '../StepWrapper';
import SettingsProject from '@/pages/settings-project';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step8BillingSetup({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Configure how invoices are numbered and when unbilled WIP is considered aged — critical before raising your first invoice."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-foreground">Billing Setup</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Set your invoice numbering method and define when work-in-progress is flagged as aged on reports and dashboards.
        </p>
      </div>
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsProject defaultTab="billing" />
      </div>
    </StepWrapper>
  );
}
